import { useEffect } from "react";
import { useParams, Navigate, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SUPPORTED_LANGS = ["en", "nl"] as const;

const LanguageWrapper = () => {
    const { lang } = useParams<{ lang: string }>();
    const { i18n } = useTranslation();

    useEffect(() => {
        if (lang && (SUPPORTED_LANGS as readonly string[]).includes(lang) && i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    if (!lang || !(SUPPORTED_LANGS as readonly string[]).includes(lang)) {
        return <Navigate to="/en" replace />;
    }

    return <Outlet />;
};

export default LanguageWrapper;
